import React from "react";
import { BLOK_ARRAY } from "../../../prop_types";
import * as classes from "./description_list.module.scss";
import DescriptionListItem from "./description_list_item";

export default function DescriptionList({ children }) {
  const classNames = [classes.descriptionList];

  return (
    <dl className={classNames.join(" ")}>
      {children &&
        children.map((item) => {
          return <DescriptionListItem {...item} />;
        })}
    </dl>
  );
}

DescriptionList.defaultProps = {
  children: null,
};

DescriptionList.propTypes = {
  children: BLOK_ARRAY,
};
